export default "__VITE_ASSET__CuZxVYFi__"